// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

export const AI_BUILDER = {
  selectMutualFunds: (
    <Translation
      i18nKey="aiBuilder.selectMutualFunds"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
  selectETFs: (
    <Translation
      i18nKey="aiBuilder.selectETFs"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
  selectUniverse: (
    <Translation
      i18nKey="aiBuilder.selectUniverse"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export const AI_BUILDER_THEMATICS = {
  XBI: (
    <Translation
      i18nKey="aiBuilder.XBI"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  ARKK: (
    <Translation
      i18nKey="aiBuilder.ARKK"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  XSD: (
    <Translation
      i18nKey="aiBuilder.XSD"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  CIBR: (
    <Translation
      i18nKey="aiBuilder.CIBR"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  ACES: (
    <Translation
      i18nKey="aiBuilder.ACES"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  IDRV: (
    <Translation
      i18nKey="aiBuilder.IDRV"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  AQWA: (
    <Translation
      i18nKey="aiBuilder.AQWA"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  METV: (
    <Translation
      i18nKey="aiBuilder.METV"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export const AI_BUILDER_SELECT_OBJETIVE = {
  /** DirectIndexing */
  min_tracking_error: (
    <Translation
      i18nKey="aiBuilder.min_tracking_error"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  equal_weights: (
    <Translation
      i18nKey="aiBuilder.equal_weights"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  market_cap: (
    <Translation
      i18nKey="aiBuilder.market_cap"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  max_diversification_ratio: (
    <Translation
      i18nKey="aiBuilder.max_diversification_ratio"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  min_volatility: (
    <Translation
      i18nKey="aiBuilder.min_volatility"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  min_risk_parity: (
    <Translation
      i18nKey="aiBuilder.min_risk_parity"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  min_neg_sharpe_ratio: (
    <Translation
      i18nKey="aiBuilder.min_neg_sharpe_ratio"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export const AI_BUILDER_OPTIMIZATION_PARAMETERS = {
  selectOptimizationParameters: (
    <Translation
      i18nKey="aiBuilder.selectOptimizationParameters"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  numberOfPositions: (
    <Translation
      i18nKey="aiBuilder.numberOfPositions"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  positionsWeights: (
    <Translation
      i18nKey="aiBuilder.positionsWeights"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),

  optimizationHistoricalWindow: (
    <Translation
      i18nKey="aiBuilder.optimizationHistoricalWindow"
      ns="popups"
      components={[<p className="text-justify" />]}
    />
  ),
};

export type AiBuilderPopupName =
  | keyof typeof AI_BUILDER
  | keyof typeof AI_BUILDER_THEMATICS
  | keyof typeof AI_BUILDER_SELECT_OBJETIVE
  | keyof typeof AI_BUILDER_OPTIMIZATION_PARAMETERS;
